import { Action, ApiState } from '../../types';
import { serviceReducer } from '../../shared/hooks/serviceReducer';
import { RolePermissionUser } from '../../services/types/Admin';

export type RolePermissionAction =
  | Action<RolePermissionUser[], void>
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<RolePermissionUser[], void>,
  action: Action<RolePermissionUser[], void>
): ApiState<RolePermissionUser[], void> => {
  switch (action.type) {
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
